import { GiHealthCapsule } from "react-icons/gi";
import { TbMathSymbols } from "react-icons/tb";
import { AiOutlineAntDesign } from "react-icons/ai";
import { MdSocialDistance, MdEngineering } from "react-icons/md";
import { SiBlockchaindotcom } from "react-icons/si";

export const categories = [
  {
    id: "arts-and-humanities",
    title: "Arts and Humanities",
    icon: <AiOutlineAntDesign />,
  },
  {
    id: "medicine-and-health",
    title: "Medicine and Health",
    icon: <GiHealthCapsule />,
  },
  {
    id: "science-and-mathematics",
    title: "Science and Mathematics",
    icon: <TbMathSymbols />,
  },
  {
    id: "social-science",
    title: "Social Sciences",
    icon: <MdSocialDistance />,
  },
  {
    id: "web-3.0-Blockchain",
    title: "Web 3.0 & Blockchain",
    icon: <SiBlockchaindotcom />,
  },
  // {
  //   id: "agriculture-science",
  //   title: "Agricultural Sciences",
  //   icon: <GiPlantsAndAnimals />,
  // },
  {
    id: "engineering-and-technology",
    title: "Engineering and Technology",
    icon: <MdEngineering />,
  },
  // {
  //   id: "asian-based-grant",
  //   title: "Asian-Based Grant Initiative for DeSci",
  //   icon: <MdDiversity3 />,
  // },
];
export const projectStates = [
  "Open Calls",
  "Closed Call",
  "Successfully Funded",
  "Ending Soon",
  "Nearly There",
];

export const resultTypes = [
  "Technical Report",
  "Algorithm",
  "Dataset",
  "Pre-prints paper",
  "Scientific illustration",
  "Open Access paper",
  "Educational Material",
  "Open Source Software",
  "Other",
];
